/**
 * @fileoverview > handler for the "/engagement/api/segment_cohorts/:id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementApiSegmentCohortsIdCacheKeys } from "./constants";
import type { SegmentCohortList, PatchEngagementApiSegmentCohortsIdProps } from "./types";

export const patchSegmentCohort = reactQueryMutationAdapter(
  engagementApiSegmentCohortsIdCacheKeys,
  (props: PatchEngagementApiSegmentCohortsIdProps): Promise<SegmentCohortList> => {
    return fetch(
      `/engagement/api/segment_cohorts/${props.segmentCohortId}`,
      "PATCH",
      {
        segment_cohorts: [props.segmentCohort],
      },
      {},
      { propagateFetchRequestError: false }
    );
  }
);
